module.exports = __webpack_public_path__ + "img/53400.3ca7ef35.jpg";